import firebase from "@firebase/app";
import config from "./config";

export default firebase.initializeApp(config);
